import { Component, Input, Output, EventEmitter, HostListener } from "@angular/core";

import { DimensionName } from "../shared/project/cards/dimension-name";

@Component({
    selector: 'dimension-label',
    templateUrl: './dimension-label.component.html',
    host: {
        'class': 'ellipse',
        '[class.ellipse-hover-full-icons]': 'isHovered',
        '[style.--background-color]': 'dimensionName.bgColor',
        '[style.--color]': 'dimensionName.fontColor',
        '[attr.content]': 'dimensionName.name'
    }
})
export class DimensionLabel {
    @Input() dimensionName: DimensionName;
    @Input() showRemoveBtn: boolean = true;
    @Input() showCreateSingleDimCardBtn: boolean = true;

    @Output() removeClicked: EventEmitter<DimensionName> = new EventEmitter<DimensionName>();
    @Output() createSingleDimCardClicked: EventEmitter<DimensionName> = new EventEmitter<DimensionName>();

    isHovered: boolean = false;

    @HostListener('mouseenter')
    onMouseEnter() {
        this.isHovered = true;
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.isHovered = false;
    }

    onRemoveClicked() {
        this.removeClicked.emit(this.dimensionName);
    }

    onCreateSingleDimCardClicked() {
        this.createSingleDimCardClicked.emit(this.dimensionName);
    }
}
